// 搜索关键词最大长度
export const SEARCH_KEYWORD_MAX_LENGTH = 60
